// src/Pages/ViewRecipes.js
import React from 'react';

const ViewRecipes = () => {
    return (
        <div>
            <h1>Eindgebruikers</h1>
            <p>Alleen toegankelijk voor Eindgebruikers.</p>
        </div>
    );
};

export default ViewRecipes;
